(function () {
  function initLanding(root) {
    if (!root) return;

    function initAOS() {
      if (typeof AOS === 'undefined') return;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      AOS.init({ duration: 800, once: true, offset: 100, disable: prefersReducedMotion });
    }

    if (typeof Swiper !== 'undefined') {
      root.querySelectorAll('.swiper').forEach(function (el) {
        if (el.dataset.sfLandingSwiperInitialized === 'true') return;
        el.dataset.sfLandingSwiperInitialized = 'true';

        var resizeTimer;
        var swiper = new Swiper(el, {
          slidesPerView: 1,
          pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
          breakpoints: { 768: { slidesPerView: 3, loop: false, spaceBetween: 32 } },
          on: {
            init: function (instance) { checkEdgeCases(instance); if (typeof AOS !== 'undefined') AOS.refresh(); },
            resize: function (instance) {
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(function () {
                instance.update();
                checkEdgeCases(instance);
                if (typeof AOS !== 'undefined') AOS.refresh();
              }, 250);
            }
          }
        });

        swiper.on('slideChangeTransitionStart', function () { swiper.allowTouchMove = false; });
        swiper.on('slideChangeTransitionEnd', function () {
          swiper.allowTouchMove = true;
          if (typeof AOS !== 'undefined') AOS.refresh();
        });

        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) {
            swiper.update();
            if (typeof AOS !== 'undefined') AOS.refresh();
          }
        });

        window.addEventListener('orientationchange', function () {
          setTimeout(function () {
            swiper.update();
            checkEdgeCases(swiper);
            if (typeof AOS !== 'undefined') AOS.refresh();
          }, 150);
        });
      });
    }

    initAOS();
  }

  function getRealSlideCount(swiperInstance) {
    if (!swiperInstance.el) return 0;
    return swiperInstance.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
  }

  function checkEdgeCases(swiperInstance) {
    if (!swiperInstance.el) return;
    var totalSlides = getRealSlideCount(swiperInstance);
    var isDesktop = window.innerWidth >= 768;
    var paginationEl = swiperInstance.pagination && swiperInstance.pagination.el;

    if (totalSlides === 0) {
      swiperInstance.el.style.display = 'none';
      return;
    }

    if (totalSlides === 1) {
      swiperInstance.allowTouchMove = false;
      if (swiperInstance.params.loop) {
        swiperInstance.loopDestroy();
        swiperInstance.params.loop = false;
      }
      if (paginationEl) paginationEl.style.visibility = 'hidden';
    } else {
      swiperInstance.allowTouchMove = true;
      if (paginationEl) paginationEl.style.visibility = 'visible';
    }

    if (isDesktop && totalSlides < 3) {
      swiperInstance.params.slidesPerView = totalSlides;
      swiperInstance.update();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sf-landing').forEach(initLanding);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initLanding(event.target.querySelector('.sf-landing'));
  });
})();